<template>
  <div class="card" >
    <div  v-show="isReady">
     <form v-if="normalizationKey.data" @submit.prevent="addOrUpdateShopInvoiceNormalizationConfig" class="form g-3">
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">{{ $t('normalized.title') }}</h3>
        </div>
        <div class="card-toolbar">
          <button type="submit" class="btn btn-sm btn-primary" v-if="$can('normalized_invoice_view')" :disabled="isLoading">
            <span class="indicator-label" v-if="!isLoading">
              <span v-if="normalizationKey.id != null">{{ $t('button.edit') }}</span>
              <span v-else>{{ $t('button.save') }}</span>
            </span>
            <span class="" v-else>{{ $t('loading') }}
              <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
          </button>
        </div>
      </div>
      <!--begin::Card body-->
      <div class="card-body">
          <div class="d-flex flex-column mb-8 fv-row">
            <!--begin::Label-->
            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
              <span>{{ $t('normalized.forms.ifu') }}</span>
            </label>
            <!--end::Label-->
            <input class="form-control" :value="societyIfu || $t('normalized.forms.ifu_missing')" disabled />
            <div class="text-muted fs-7 mt-2">
              {{ $t('normalized.forms.ifu_hint') }}
              <router-link :to="{ name: 'society-config' }">{{ $t('setting.config') }}</router-link>
            </div>
          </div>
          <div class="d-flex flex-column mb-8 fv-row">
            <!--begin::Label-->
            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
              <span class="required">{{ $t('normalized.forms.invoice_type') }}</span>
            </label>
            <!--end::Label-->
            <input class="form-control" :placeholder="$t('normalized.forms.invoice_type')" disabled
              v-model="normalizationKey.data.invoice_type" required />
          </div>
          <div class="d-flex flex-column mb-8 fv-row">
            <!--begin::Label-->
            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
              <span class="required">{{ $t('normalized.forms.tokenApi') }}</span>
            </label>
            <!--end::Label-->
            <input class="form-control" :placeholder="$t('normalized.forms.tokenApi')"
              v-model="normalizationKey.data.tokenApi" required />
          </div>
          <div class="d-flex flex-column mb-8 fv-row">
            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
              <span class="required">{{ $t('normalized.forms.defaultTaxe') }}</span>
            </label>
            <select class="form-select" v-model="normalizationKey.data.defaultTaxe" data-placeholder="Select an option">
              <option value="A">A - EXONERE</option>
              <option value="B">B - TAXABLE 18%</option>
              <option value="C">C - EXPORTATION</option>
              <option value="D">D - TVA REGIME D'EXCEPTION 18%</option>
              <option value="E">E - RIGIME TPS</option>
              <option value="F">F - RESERVE</option>
            </select>
          </div>
          <div class="form-check form-switch form-check-custom form-check-solid">
              <input class="form-check-input" type="checkbox" v-model="normalizationKey.automatic" id="flexSwitchChecked" />
              <label class="form-check-label" for="flexSwitchChecked">
                {{ $t('normalized.forms.automatic') }}
              </label>
          </div>
      </div>
    </form>
    </div>
    <div class="container-xxl" v-show="!isReady">
      <div class="row loader text-center">
        <Loader />
      </div>
    </div>

  </div>
</template>

<script>
import { BASE_IMAGE_URL, BASE_URL } from "@/services/api";
import { mapActions, mapGetters } from "vuex";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    Loader
  },
  data() {
    return {
      isLoading: false,
      status: null,
      removeUser: false,
      shopActiveUsers: {},
      normalizationKey: {},
      isReady: false,
      societyIfu: null,
    }
  },
  async mounted() {
    this.isReady = false
    await this.loadNormalizationKey()
    await this.loadSocietyIfu()
    this.isReady = true
  },
  methods: {
    ...mapActions('core', ['getSocietyInfo']),
    ...mapActions('shop', [
      'getShopNormalizationKey',
      'addShopNormalizedKey',
      'updateShopNormalizedKey'
    ]),
    async loadSocietyIfu() {
      const response = await this.getSocietyInfo({ key: 'default' })
      this.societyIfu = response.data?.societyInfo?.ifu_number || null
    },
    async loadNormalizationKey() {
      let response = await this.getShopNormalizationKey('symef-benin')
      this.normalizationKey = response.data
      if (!this.normalizationKey.data) {
        this.normalizationKey = {
          data: {
            ifu: null,
            invoice_type: 'FV',
            tokenApi: null,
            defaultTaxe: 'B'
          },
          key: "symef-benin",
          id: null,
          automatic: false
        }
      }
    },
    async addOrUpdateShopInvoiceNormalizationConfig() {
      this.isLoading = true
      try {
        if (this.normalizationKey.id != null) {
          await this.updateShopNormalizedKey(this.normalizationKey)
        } else {
          await this.addShopNormalizedKey(this.normalizationKey)
        }
        await this.loadNormalizationKey()
        window.toastr['success'](i18n.global.t("normalized.forms.success"))
        $('#modal-add-or-update-invoice-config').modal('toggle')
      } catch (e) {
        window.toastr['error'](e)
        this.isLoading = false
      }
      this.isLoading = false
    },
  }
}
</script>

<style scoped>
.badge {
  display: none !important;
  align-items: center;
}

.badge-light-danger {
  color: #f1416c;
  background-color: #fff5f8;
  padding: 15px !important;
  text-align: center !important;
}
</style>
